import React from 'react';
import { observer } from 'mobx-react';

import type { AccordionHeaderProps } from 'shared/Accordion/components/AccordionWrapper';
import AccordionFormHeader from '../AccordionFormHeader';

export interface PackingListHeaderProps extends AccordionHeaderProps {
  completed: boolean;
}

const PackingListHeader = ({ expanded, completed }: PackingListHeaderProps) => (
  <AccordionFormHeader
    expanded={expanded}
    headline={I18n.translate('exports.form.packing_list.header')}
    completed={completed}
  />
);

export default observer(PackingListHeader);
